import { render } from "./TesteCargaFormulario.vue?vue&type=template&id=61c5b0e1&scoped=true"
import script from "./TesteCargaFormulario.vue?vue&type=script&lang=js"
export * from "./TesteCargaFormulario.vue?vue&type=script&lang=js"

import "./TesteCargaFormulario.vue?vue&type=style&index=0&id=61c5b0e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c5b0e1"]])

export default __exports__